module.exports = __webpack_public_path__ + "static/media/Kendo.ba0ca458.jpg";